<template>
  <layout-main>
    <div class="main-container">
      <div class="my-10 md:flex md:items-center md:justify-between">
        <div class="min-w-0 flex-1">
          <h2 class="text-2xl font-semibold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            Facility Company Name
          </h2>
        </div>
        <div class="mt-4 flex md:ml-4 md:mt-0 gap-x-3">
          <button type="button" class="btn">
            Cancel
          </button>
          <button type="button" class="btn-outline">
            Edit
          </button>
          <button type="button" class="btn-primary">
            Whatever
          </button>
        </div>
      </div>

      <dl class="mb-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <div v-for="item in stats" :key="item.name" class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
          <dt class="truncate text-sm font-medium text-gray-500">
            {{ item.name }}
          </dt>
          <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-700">
            {{ item.stat }}
          </dd>
        </div>
      </dl>

      <div class="my-10">
        <h2 class="text-2xl font-semibold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
          Clients (5)
        </h2>
      </div>

      <div class="my-10">
        <ul role="list" class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
          <li v-for="client in clients" :key="client.id" class="rounded-xl bg-white shadow">
            <div class="flex items-center gap-x-4 p-6">
              <BriefcaseVariant class="h-6 w-6 text-gray-500" aria-hidden="true" />
              <div class="text-lg font-medium leading-6 text-gray-700">
                {{ client.name }}
              </div>
              <Menu as="div" class="relative ml-auto">
                <MenuButton class="-m-2.5 block p-2.5 text-gray-400 hover:text-gray-500">
                  <span class="sr-only">Open options</span>
                  <DotsVertical class="h-5 w-5" aria-hidden="true" />
                </MenuButton>
                <transition
                  enter-active-class="transition ease-out duration-100"
                  enter-from-class="transform opacity-0 scale-95"
                  enter-to-class="transform opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75"
                  leave-from-class="transform opacity-100 scale-100"
                  leave-to-class="transform opacity-0 scale-95"
                >
                  <MenuItems class="absolute right-0 z-10 mt-0.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                    <MenuItem v-slot="{ active }">
                      <a
                        href="#"
                        :class="[active ? 'bg-primary-50' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900']"
                      >View<span class="sr-only">, {{ client.name }}</span></a>
                    </MenuItem>
                    <MenuItem v-slot="{ active }">
                      <a
                        href="#"
                        :class="[active ? 'bg-primary-50' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900']"
                      >Edit<span class="sr-only">, {{ client.name }}</span></a>
                    </MenuItem>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
            <div class="px-6 pb-6 text-sm text-gray-500">
              5 Properties
            </div>
          </li>
        </ul>
      </div>
    </div>
  </layout-main>
</template>

<script setup>
import LayoutMain from '../layouts/LayoutMain.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DotsVertical from 'vue-material-design-icons/DotsVertical.vue';
import BriefcaseVariant from 'vue-material-design-icons/BriefcaseVariant.vue';

const stats = [
  { name: 'New Service requests', stat: '71 897' },
  { name: 'Open work orders', stat: '5 816' },
  { name: 'Equipment maintenance', stat: '24.57%' },
  { name: 'Whatever', stat: '8.73%' }
];

const clients = [
  {
    id: 1,
    name: 'Lux development'
  },
  {
    id: 2,
    name: 'Kyivmiskbud'
  },
  {
    id: 3,
    name: 'Reform'
  },
  {
    id: 4,
    name: 'Bayraktar'
  },
  {
    id: 5,
    name: 'Whatever'
  }
];

</script>
